import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { Button, ButtonVariant } from '@egw/components'
import { ActivateCardStepEnum, type TFlowModals, TRANSLATION_KEY_PREFIX } from '.'

const InitStep: FC<TFlowModals> = ({ step, setStep }) => {
  const { t } = useTranslation('features-account')

  const ctaHandler = (): void => {
    setStep(ActivateCardStepEnum.ACTIVATE)
  }

  return (
    <div className="flex flex-col gap-4" id="activateCardInitStep">
      <span>{t(`${TRANSLATION_KEY_PREFIX}${step}.description`)}</span>
      <Button variant={ButtonVariant.Primary} id="initStepCta" onClick={ctaHandler}>
        {t('debit_card.continue')}
      </Button>
    </div>
  )
}

export default InitStep
